import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = { newUrl: String }

  connect() {
    this.handler = (e) => this.handle(e)
    document.addEventListener("keydown", this.handler)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handler)
  }

  handle(e) {
    const tag = e.target.tagName
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || e.target.isContentEditable) return

    if (e.key === "/") {
      e.preventDefault()
      const input = document.querySelector('[data-search-target="input"]')
      if (input) input.focus()
    } else if (e.key === "n" && !e.metaKey && !e.ctrlKey) {
      e.preventDefault()
      if (this.newUrlValue) window.Turbo.visit(this.newUrlValue)
    } else if (e.key === "?") {
      e.preventDefault()
      this.toggleModal()
    }
  }

  toggleModal() {
    if (this.hasModalTarget) {
      this.modalTarget.classList.toggle("hidden")
    }
  }

  closeModal() {
    if (this.hasModalTarget) {
      this.modalTarget.classList.add("hidden")
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
